import React, { Component } from 'react';
import { 
  BrowserRouter,
  Route,
  Link,
  Redirect,
  withRouter 
} from 'react-router-dom';



import BedsDashboard from './BedsDashboard/BedsDashboard';

import VolunteerForm from './VolunteerForm/VolunteerForm';
import VolunteerManage from './VolunteerManage/VolunteerManage';
import MakeRequestForm from './MakeRequestForm/RequestForm';


import './App.css';
import moment from 'moment';
import localization from 'moment/locale/ro';

import LoginForm from './LoginPage/Login';
import VoluntarLoginForm from './VoluntarLogin/VoluntarLogin';
import VoluntarRequestForm  from './VoluntarRequest/VoluntarRequest';

import AddTimeSlotForm from './VolunteerForm/AddTimeSlot/AddTimeSlotForm';

import Auth from './modules/auth'; 


moment().locale("ro", localization).format('LLL');



const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    Auth.isUserAuthenticated() === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const VoluntarPrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    Auth.isUserAuthenticatedV() === true 
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/voluntar',
        state: { from: props.location }
      }} />
  )} />
)

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <Route path="/login" component={LoginForm} />
          <Route path="/voluntar" component={VoluntarLoginForm} />
          <Route path="/vreau-voluntar" component={VoluntarRequestForm} />
          <Route path='/internare' component={MakeRequestForm} />
          <PrivateRoute exact path='/' component={BedsDashboard} />
          <PrivateRoute path='/calendar' component={VolunteerForm} />
          <PrivateRoute path='/setari-voluntari' component={VolunteerManage} />
          <VoluntarPrivateRoute path='/programare' component={AddTimeSlotForm} />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
